<template>
	<!-- создать доступ для внешних инструментов -->
	<div ng-if="overlayController" class="windowOverlay" id="getExternalLogin" ng-controller="overlayController">
		<div class="darkener clickable" clickable="closeOverlay()"></div>
		<div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="801">
			<div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
				<div class="inWindowPopupHeader">
					<h4 translate="" options="ExternalLogin" ng-if="overlayConfig['inWindowPopupTitle'] != ''"><span>Создать внешний доступ</span></h4>
					<h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4>
					<a class="closeOverlay clickable" clickable="closeOverlay()" translate=""><span>Закрыть</span></a>
				</div>
				<div class="inWindowPopupContent">
					<div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']">
						<div class="externalLoginOverlay">
							<div ng-if="!externalLoginKey">
								<div translate=""><span>Для защиты учетной записи Travian ты никогда не должен использовать пароль Travian на внешних страницах. Ты можешь создать отдельную точку доступа здесь, чтобы использовать внешние страницы (которые поддерживают эту опцию) без регистрации.</span></div>
								<div translate=""><span>Внешняя страница, поддерживающая этот доступ, должна отображать публичный "ключ страницы" на странице входа в игру. Введи его здесь, чтобы создать ключ доступа:</span></div>
								<div class="siteKeyInputContainer">
									<label class="insertInputLabel">
										<span translate=""><span>Ключ страницы</span></span>:
										<input ng-model="input.publicSiteKey" id="publicSiteKey" name="publicSiteKey" type="text" class="ng-pristine ng-untouched ng-valid" />
									</label>
								</div>
								<div class="buttonFooter">
									<button clickable="requestExternalLogin();" ng-class="{disabled: input.publicSiteKey == null || input.publicSiteKey == ''}" class="clickable disabled">
										<div class="content">
											<span ng-transclude="" class="innerText">
												<span translate=""><span>Создать доступ</span></span>
											</span>
											<!-- ngIf: price > 0 || forceGoldUsage -->
											<!-- ngIf: price == -1 && !forceGoldUsage -->
											<div class="animationOverlay"></div>
											<i class="checkmark action_check_small_flat_white"></i>
											<i class="checkmark action_check_small_flat_black"></i>
											<i class="checkmark action_check_small_flat_red"></i>
										</div>
									</button>
								</div>
								<div class="error"></div>
							</div>
							<!-- ngIf: externalLoginKey -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	mounted(){},
	components: {},
}
</script>